import _ from "lodash";
import { Suspense, useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaPlus } from "react-icons/fa";
import { FiDownload, FiSend } from "react-icons/fi";
import MainCard from "../../../Components/Cards/MainCard";
import { Button, Input } from "../../../Components/CustomComponents";
import SelectFieldComponent from "../../../Components/CustomComponents/SelectFieldComponent";
import ToolTip from "../../../Components/CustomComponents/ToolTip";
import SendReferralAgreementModal from "../../../Components/Modals/SendReferralAgreementModal";
import Table from "../../../Components/Table/Table";
import {
  useBlockUserMutation,
  useUnBlockUserMutation,
} from "../../../Data/services/generalUserApi";
import Toast, { SuccessToast } from "../../../Hooks/useToast";
import styles from "../styles/user_management.module.scss";
import Header from "./Header";
import EditAgreementModal from "../../../Components/Modals/EditAgreementModal";
import ReferralAgreementSkeleton from "../../../Components/Skeleton/ReferralAgreementSkeleton";

const ReferralAgreements = ({ data }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
      states: "",
    },
  });
  const status = watch("status");
  const states = watch("states");
  // console.log(status);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [newAgreementModal, setNewAgreementModal] = useState(false);
  const [forView, setForView] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [dataFetched, setDataFetched] = useState(false);

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setDataFetched(false);
  };

  const handleSendModalOpen = () => {
    setViewModal(true);
  };

  const handleSendModalClose = () => {
    setViewModal(false);
    setEditedData("");
  };

  const handleAddAgreementModalOpen = () => {
    setNewAgreementModal(true);
  };

  const handleAddAgreementModalClose = () => {
    setNewAgreementModal(false);
    setEditedData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  // const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const deleteData = async (slug) => {
    // try {
    //   // const { data } = await deleteUser(slug);
    //   // console.log(data);
    //   if (data.code === 200) {
    //     // await refetch();
    //     handleDeleteModalClose();
    //     SuccessToast(data.message);
    //   }
    // } catch (error) {
    //   // console.log(error);
    //   Toast(error.message, "error");
    // }
  };

  function indication() {
    return indicationMessage;
  }

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();
  // const [userBlockOrUnBlock, { isLoading: isSwitching }] =
  //   useBlockUnblockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      // const response = await userBlockOrUnBlock({ id: userSlug });
      // console.log(response);
      let response;
      if (isBlock) {
        response = await unBlockUser({ id: userSlug });
      } else {
        response = await blockUser({ id: userSlug });
      }
      console.log(response);

      if (response.data.code === 200) {
        // await refetch();
        setLoading(false);
        // handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  const columns = [
    {
      dataField: "agent",
      text: "Agent",
      headerStyle: { width: "250px" },
      formatter: (cellContent, row) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar bg-light rounded-circle p-2 fw-bold">
            {row.name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </div>
          <div>
            <div className="fw-bold">{row.name}</div>
          </div>
        </div>
      ),
    },

    {
      dataField: "brokerage",
      text: "Brokerage",
      headerStyle: { width: "200px" },
    },

    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent) => {
        let badgeClass =
          cellContent === "Signed"
            ? "bg-success"
            : cellContent === "Pending"
            ? "bg-warning text-dark"
            : cellContent === "Completed"
            ? "bg-primary"
            : "bg-danger";

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },

    {
      dataField: "state",
      text: "State",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "100px" },
    },

    {
      dataField: "created",
      text: "Created",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "160px" },
    },

    {
      dataField: "signed",
      text: "Signed",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "160px" },
    },

    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "200px" },
      formatter: (cellContent, row) => (
        <div className="d-flex justify-content-center gap-2">
          <ToolTip placement={"top"} content={"Send"}>
            <button
              className="btn btn-sm btn-success rounded-circle pb-2"
              onClick={() => {
                setEditedData(row);
                handleSendModalOpen();
              }}
            >
              <FiSend />
            </button>
          </ToolTip>
          <ToolTip placement={"top"} content={"Download"}>
            <button
              className="btn btn-sm btn-primary rounded-circle pb-2"
              onClick={() => alert(`Downloading agreement of ${row.name}`)}
            >
              <FiDownload />
            </button>
          </ToolTip>
        </div>
      ),
    },
  ];

  return (
    <>
      {viewModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <SendReferralAgreementModal
            // forView={forView}
            handleEditModalClose={handleSendModalClose}
            editData={editedData}
            // onAction={handleBlockOrUnblock}
            // loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {newAgreementModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditAgreementModal
            // forView={forView}
            handleEditModalClose={handleAddAgreementModalClose}
            editData={editedData}
            // onAction={handleBlockOrUnblock}
            // loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {/* {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            // isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )} */}

      <Header title={"ReferralAgreements"} />
      <br />

      <MainCard>
        {dummyFetch.isLoading ? (
          <ReferralAgreementSkeleton />
        ) : (
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={6}>
                <Input
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Col>
              <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                <Controller
                  control={control}
                  name="status"
                  render={({ field: { onChange, value } }) => (
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  )}
                />
              </Col>
              <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                <Controller
                  control={control}
                  name="states"
                  render={({ field: { onChange, value } }) => (
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  )}
                />
              </Col>
              <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                <Button
                  classes={`${styles.cardBtn} px-3 w-100`}
                  text={
                    <span className="d-flex align-items-center justify-content-center gap-2 small text-truncate">
                      <FaPlus size="14px" />
                      <span className="d-none d-md-inline">New Agreement</span>
                    </span>
                  }
                  onClick={handleAddAgreementModalOpen}
                ></Button>
              </Col>
            </Row>

            <div
              // className={`${styles.mainTable} ${dataFetched && isFetching ? "blur-table" : ""}`}
              className={styles.mainTable}
            >
              {/* {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : ( */}
              <Table
                // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={data || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}}
              />
              {/* )} */}
            </div>
          </>
        )}
      </MainCard>
    </>
  );
};

export default ReferralAgreements;
